import { VSpacer } from 'vuetify/lib'
import { COMPANY_FIELD } from '../type_name'
import { CompanyName } from '../components_from_custumer'
export default {
    name: COMPANY_FIELD,
    props: {
        field: {
            type: Object,
        },
        value: {
            type: Object
        }
    },
    methods: {
        // 生成 VSpacer
        setVSpacer(h) {
            if (this.vSpacer) {
                return this.vSpacer
            }
            return this.vSpacer = h(VSpacer)
        }
    },
    render(h) {
        const { label, key, textRender } = this.field
        let id = 0
        if (textRender) {
            id = textRender({field:this.field, value:this.value})
        } else {
            id = this.value[key]
        } 
        return h('div', {
            style: {
                width: '100%',
                display: 'flex'
            }
        }, [
            h('span', {
                style:{
                    'white-space':'nowrap',
                    'margin-right': '10px'
                }
            }, label),
            this.setVSpacer(h),
            h(CompanyName, {
                props: {
                    id,
                    short:true
                }
            })
        ])
    }
}